<mat-form-field class="w-full">
  <mat-label>Search for a template</mat-label>
  <input matInput [formControl]="searchControl" [matAutocomplete]="auto" />
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="templateSelected.emit($event.option.value)"
    [displayWith]="emptyDisplayWith"
  >
    @if (filteredTemplates$ | async; as filteredTemplates) {
      @if (filteredTemplates.length === 0) {
        <mat-option
          *ngIf="noTemplates$ | async; else noMatches"
          [value]="null"
          [disabled]="true"
        >
          No templates set up
        </mat-option>
        <ng-template #noMatches>
          <mat-option [value]="null" [disabled]="true">
            No templates found
          </mat-option>
        </ng-template>
      }
      <mat-option *ngFor="let template of filteredTemplates" [value]="template">
        {{ template.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
